import React, { useMemo } from 'react';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import { RootStore } from '@/models';
import { MainChannel } from '@/models/simultaneousInterpretation';
import { Icon } from '@/components';
import s from './index.less';

interface ModelState {
  simultaneous?: RootStore['simultaneousInterpretation'];
}

interface Props extends ModelState {}

const SwitchLanguage: React.FC<Props> = inject(({ store }) => {
  return {
    simultaneous: store.simultaneousInterpretation,
  };
})(
  observer((props) => {
    const { simultaneous } = props;
    const { curChannel, allChannels } = simultaneous || {};
    const memoChannel = useMemo(() => {
      if (curChannel !== MainChannel) {
        const item = allChannels?.filter((item) => item.yxSubchannelName === curChannel)[0];
        if (item) {
          return item.iconWord;
        }
      }
      return '';
    }, [curChannel, allChannels]);
    return curChannel === MainChannel ? (
      <Icon className={s.icon} name="icon-biography2" />
    ) : (
      <div className={s.sizeBox}>
        <span className={classNames(s.icon, s.size)}>{memoChannel}</span>
      </div>
    );
  })
);
export default SwitchLanguage;
